import { DataInput, InputSource } from '@/types/automationFields.ts';

export const inputSourceAcceptsUserSpecified = (inputSource: InputSource) =>
  inputSource === InputSource.UserSpecified || inputSource === InputSource.Both;

export const inputSourceAcceptsDataInput = (inputSource: InputSource) =>
  inputSource === InputSource.FromDataset || inputSource === InputSource.Both;

export const isConfiguredDataInput = (dataInput: DataInput | undefined): dataInput is DataInput => {
  if (!dataInput) return false;

  const config = dataInput.config;
  return (
    ('static_dataset_id' in config && Boolean(config.static_dataset_id)) ||
    ('linked_dataset_id' in config && Boolean(config.linked_dataset_id)) ||
    ('source_step_id' in config && Boolean(config.source_step_id)) ||
    ('dataset_type' in config && Boolean(config.dataset_type))
  );
};

export const getMultiLogicDataInputs = (dataInputs: DataInput[] | undefined) => {
  const configuredDataInputs = dataInputs?.filter(isConfiguredDataInput) ?? [];
  if (configuredDataInputs.length) return configuredDataInputs;
  return [];
};
